import { render } from "./TradePermit.vue?vue&type=template&id=1cabe8df&scoped=true"
import script from "./TradePermit.vue?vue&type=script&lang=js"
export * from "./TradePermit.vue?vue&type=script&lang=js"

import "./TradePermit.vue?vue&type=style&index=0&id=1cabe8df&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cabe8df"]])

export default __exports__